import React from "react";

const Projects = () => {
  return (
    <section id="projects" >
     
    <div className="project">
    
    
   

          <h3 >SELF-DRIVEN MODELING</h3>
          <br />
          <div className="a3">
            <a href="https://github.com/sevenjunebaby/AI-7j">
              <img src="https://specials-images.forbesimg.com/imageserve/65c08bba43faeeedd41c7a2f/960x0.jpg" alt="frontend" />  
            </a>
            <a href="https://github.com/sevenjunebaby/RAG">
              <img src="https://technation.news/wp-content/uploads/2025/07/From-LLMs-to-RAG.png" alt="rag" />  
            </a>
            <a href="https://github.com/sevenjunebaby/Xpro">
              <img src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/blogs/22606/images/1446e76-f181-6047-4e73-8d8ba3c6a50e_object_detection_1.webp" alt="rag" />  
            </a>
          </div>
          <div>
            <br />
            <div className="a3">
              <a href="https://github.com/sevenjunebaby/Machine_Learning">
                <img src="https://www.repsol.com/content/dam/repsol-corporate/es/energia-e-innovacion/robot-machine-learning.jpg.transform/rp-rendition-sm/image.jpg" alt="link" ></img>
              </a>
              <a href="https://github.com/sevenjunebaby/Clustering">
                <img src="https://online.keele.ac.uk/media/mageplaza/blog/post/d/a/data-clustering.jpg" alt="link" ></img>
              </a>
              <a href="https://github.com/sevenjunebaby/Classification">
                <img src="https://www.lepide.com/blog/wp-content/uploads/2020/03/role-of-data-classification.png" alt="link" ></img>
              </a>
            </div>
          </div>
        </div>
       
    
    </section>
  );
};

export default Projects;
